import PageHeader from "../PageHeader";
import { ReactComponent as LearnerIcon } from "../../images/learnersimage/learnericon.svg";
import useStyles from "../../../styles";
import ReportHeader from "../../CustomComponent/ReportHeaderNotPreview";
import { Report6Api } from "../../../service/services";
import Loader from "../../CustomComponent/Loader";
import { useState } from "react";

function ResponseReport() {
  const classes = useStyles();
  const [loaderOpen, setLoaderOpen] = useState(false);

  const Heading = [
    {
      id: 1,
      pageicon: <LearnerIcon />,
      mainheading: "Response Report",
    },
  ];

  return (
   <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <Loader loaderOpen={loaderOpen} />
      <PageHeader Heading={Heading} />
      <ReportHeader exportApi={Report6Api} setLoaderOpen={setLoaderOpen} />
    </div>
  );
}
export default ResponseReport;
